import { getDatabaseSizeMetrics } from '@databases/analytics';
import {
  unstable_IdlePriority as idlePriority,
  unstable_scheduleCallback as scheduleCallback
} from 'scheduler';

import { type MetricNameValue, ReliabilityMetrics } from '@canvas/frontend-metrics';

interface MetricData {
  id: string;
  startTime: number;
}

export class PerformanceTimingManager {
  private static metricStartTimes: Map<string, MetricData> = new Map();

  static getMetricIdHash(metricName: MetricNameValue, id: string): string {
    return `${metricName},${id}`;
  }

  static startMetricTiming({
    metricName,
    id,
    startTime
  }: {
    metricName: MetricNameValue;
    id: string;
    startTime: number;
  }): void {
    const hash = PerformanceTimingManager.getMetricIdHash(metricName, id);

    PerformanceTimingManager.metricStartTimes.set(hash, { id, startTime });
  }

  static endMetricTiming({
    metricName,
    id
  }: {
    metricName: MetricNameValue;
    id: string;
  }): void {
    const endTime = performance.now();
    const hash = PerformanceTimingManager.getMetricIdHash(metricName, id);
    const metricData = PerformanceTimingManager.metricStartTimes.get(hash);

    PerformanceTimingManager.metricStartTimes.delete(hash);

    if (!metricData) {
      return;
    }

    const { contentId } = getDatabaseSizeMetrics();

    scheduleCallback(idlePriority, () => {
      void ReliabilityMetrics.getInstance().successWithDuration(
        metricName,
        metricData.startTime,
        endTime,
        { contentId: contentId || undefined }
      );
    });
  }
}
